import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUpload } from '../../../models/attachment/fileUpload';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-add-residual-report-dialog',
  templateUrl: './add-residual-report-dialog.component.html',
  standalone: false,
})
export class AddResidualReportDialogComponent {
  fileUpload: FileUpload | undefined; // this is the list of files that are currently selected for upload
  selectedMonth: string | undefined;
  selectedYear: string | undefined;
  selectedBrandId: string | undefined;
  brandOptions = [
    new ListItem({ id: 'Fast Signs', name: 'Fast Signs' }),
    new ListItem({ id: 'MY SALON SUITE', name: 'MY SALON SUITE' }),
  ];

  months = [
    new ListItem({ id: '01', name: 'January' }),
    new ListItem({ id: '02', name: 'February' }),
    new ListItem({ id: '03', name: 'March' }),
    new ListItem({ id: '04', name: 'April' }),
    new ListItem({ id: '05', name: 'May' }),
    new ListItem({ id: '06', name: 'June' }),
    new ListItem({ id: '07', name: 'July' }),
    new ListItem({ id: '08', name: 'August' }),
    new ListItem({ id: '09', name: 'September' }),
    new ListItem({ id: '10', name: 'October' }),
    new ListItem({ id: '11', name: 'November' }),
    new ListItem({ id: '12', name: 'December' }),
  ];

  years: ListItem[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      brandId: string;
    },
  ) {
    this.selectedBrandId = data.brandId;

    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i <= currentYear + 1; i++) {
      this.years.push(new ListItem({ id: i.toString(), name: i.toString() }));
    }
  }

  selectFiles_click() {
    document.getElementById('fileUpload')?.click();
  }

  onFilesSelected(event: any) {
    if (event && event.srcElement.files) {
      //this.appendFiles(event.srcElement.files);
      this.fileUpload = new FileUpload({
        file: event.srcElement.files[0],
        type: 'Residual Report',
      });
    }
  }
}
